/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Modular_Wizard_Relay_Admin_OnlyInputs */



/**
* | output |
* | --- |
* | "Only administrators can connect through a relay." |
*
* @param {Spaces_Modular_Wizard_Relay_Admin_OnlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_modular_wizard_relay_admin_only = /** @type {((inputs?: Spaces_Modular_Wizard_Relay_Admin_OnlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Modular_Wizard_Relay_Admin_OnlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Administratoren können eine Verbindung über ein Relay herstellen.")
	return /** @type {LocalizedString} */ ("Only administrators can connect through a relay.")
});